import Vue from 'vue'
import VueRouter from 'vue-router'
import routeList from './routeList'
import { login } from '@/libs/utils'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '/system/kf_center',
  routes: routeList
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.auth)) {
    login()
      .then(() => {
        next()
      })
      .catch((err) => {
        console.log(err)
      })
  } else {
    next()
  }
})

export default router
